<template>
  <component
    :is="(url) ? NuxtLink : 'button'"
    class="button-search"
    :href="url"
  >
    <span class="button-search__label">{{ title }}</span>
    <AppIconLoader name="search" variant="custom" aria-hidden="true" class="button-search__icon" />
  </component>
</template>

<script setup lang="ts">

import NuxtLink from '#app/components/nuxt-link'

const props = defineProps({
  title: { type: String, default: undefined, required: true },
  url: { type: String, required: false, default: undefined }
})

</script>

<style scoped lang="postcss">
.button-search {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  border-radius: 55px;
  border-width: 3px;
  border-color: var(--color-blue-aqua);
  background-color: var(--color-blue-aqua);
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-family: Midnight, sans-serif;
  font-size: 0.75rem;
  text-transform: uppercase;
  line-height: 0.8;
  color: var(--color-blue-prussian);
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background-color: var(--color-blue-prussian);
    color: var(--color-blue-aqua);
  }

  &:focus-visible {
    background-color: var(--color-blue-prussian);
    color: var(--color-blue-aqua);
  }

  &__label {
    margin-top: 0.125rem;
  }

  &__icon {
    margin-top: -1px;
    height: 0.625rem;
    width: 0.625rem;
    flex-shrink: 0;
  }
}
</style>
